// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jypfn","button":"styles_button__8pMQC","label":"styles_label__uVC60"};